module.exports = __webpack_public_path__ + "img/home.6dd0ef2b.svg";